var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6979 5.48665C13.1073 4.8278 12 2 12 2C12 2 10.8927 4.8278 9.30208 5.48665C7.71148 6.1455 4.92893 4.92893 4.92893 4.92893C4.92893 4.92893 6.1455 7.71148 5.48665 9.30208C4.8278 10.8927 2 12 2 12C2 12 4.8278 13.1073 5.48665 14.6979C6.1455 16.2885 4.92893 19.0711 4.92893 19.0711C4.92893 19.0711 7.71148 17.8545 9.30208 18.5134C10.8927 19.1722 12 22 12 22C12 22 13.1073 19.1722 14.6979 18.5134C16.2885 17.8545 19.0711 19.0711 19.0711 19.0711C19.0711 19.0711 17.8545 16.2885 18.5134 14.6979C19.1722 13.1073 22 12 22 12C22 12 19.1722 10.8927 18.5134 9.30208C17.8545 7.71148 19.0711 4.92893 19.0711 4.92893C19.0711 4.92893 16.2885 6.1455 14.6979 5.48665ZM8 10.25H16C16.4142 10.25 16.75 10.5858 16.75 11C16.75 11.4142 16.4142 11.75 16 11.75H8C7.58579 11.75 7.25 11.4142 7.25 11C7.25 10.5858 7.58579 10.25 8 10.25ZM10 13.25H14C14.4142 13.25 14.75 13.5858 14.75 14C14.75 14.4142 14.4142 14.75 14 14.75H10C9.58579 14.75 9.25 14.4142 9.25 14C9.25 13.5858 9.58579 13.25 10 13.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble41);
export default __webpack_public_path__ + "static/media/speech-bubble-41.e6ee7568e891cf1a1bf6eb435f920744.svg";
export { ForwardRef as ReactComponent };